module.exports = __webpack_public_path__ + "static/media/iospreview.7d591929.png";